import { useTranslation } from 'react-i18next';
import WithTooltip from '../Fundamentals/Tooltip/WithTooltip';

interface AdjustmentInputProps {
    isFixed: boolean;
    isKrOnly: boolean;
    value: string | number;
    placeholder: string;
    disabled: boolean;
    onChange: (value: string) => void;
    onBlur: () => void;
    onToggleMode: () => void;
}

const AdjustmentInput = ({ isFixed, isKrOnly, value, placeholder, disabled, onChange, onBlur, onToggleMode }: AdjustmentInputProps) => {
    const { t } = useTranslation();
    const toggleLabel = isFixed ? t('priceSimulation.switchToPercentage') : t('priceSimulation.switchToFixed');

    return (
        <div className="input-group d-inline-flex worksheet-adjustment-input">
            <input
                type={isFixed ? 'text' : 'number'}
                inputMode={isFixed ? 'text' : 'decimal'}
                className="form-control text-right"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
                onFocus={(e) => e.target.select()}
                step={isFixed ? undefined : '0.01'}
                placeholder={placeholder}
                disabled={disabled}
            />
            {isKrOnly ? (
                <span className="input-group-text pl-10">kr</span>
            ) : (
                <WithTooltip content={toggleLabel} className="input-group-text pl-10">
                    <button
                        type="button"
                        className={`bg-transparent border-0 py-2 px-0 semibold lh-1 text-primary${disabled ? '' : ' cursorpointer'}`}
                        onClick={onToggleMode}
                        aria-label={toggleLabel}
                        disabled={disabled}
                    >
                        {isFixed ? 'kr' : '%'}
                    </button>
                </WithTooltip>
            )}
        </div>
    );
};

export default AdjustmentInput;
